import {connect} from 'react-redux';

import {patchResource} from 'spectra-logic-ui/actions';
import {Dispatch, Store} from 'spectra-logic-ui';

import {fetchProduct} from '../common/fetch';
import ProductForm from './form';

const mapStateToProps = (state: Store) => {
  const products = state.resources['products'] || {};
  return {
    products: products.data || [],
    error: products.error,
    fetching: products.fetching,
    method: 'edit',
    disabledList: ['productType', 'id', 'activationKey', 'description'],
    visibleList: [
      'productType',
      'id',
      'activationKey',
      'description',
      'currentVersion',
      'lowestVersion',
      'publicKey',
    ],
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
  onSubmit: (values: any) => {
    // We only ever want to change a few things in this function
    const props = {
      currentVersion: values.currentVersion,
      lowestVersion: values.lowestVersion,
      publicKey: values.publicKey,
    };
    return dispatch(patchResource('products', values.id, props));
  },
  fetchProduct: (id: string) => fetchProduct(id, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(ProductForm);
